/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import FooterLg from './footer/FooterLg';
import FooterSm from './footer/FooterSm';
import './footer/Footer.scss';
function Footer(_ref) {
  var {
    themeConfig: {
      copyRight
    }
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-primary! footer-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block"
  }, /*#__PURE__*/React.createElement(FooterLg, null)), /*#__PURE__*/React.createElement("div", {
    className: "lg:hidden"
  }, /*#__PURE__*/React.createElement(FooterSm, null)));
}
Footer.propTypes = {
  themeConfig: PropTypes.shape({
    copyRight: PropTypes.string
  })
};
Footer.defaultProps = {
  themeConfig: {
    copyRight: '© 2025 Endorphins Art Labs. All Rights Reserved.'
  }
};
export default Footer;
;
export var query = "\n  query query {\n    themeConfig {\n      copyRight\n    }\n  }\n";